/**
 * Bundle of @industriousapps/excelkits-core
 * Generated: 2025-01-08
 * Version: 0.4.0
 * License: CC0-1.0
 */

// TODO: convert to follow HyperFormula:
// type NoErrorCellValue = number | string | boolean | null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
// Spreadsheet File Data

// NOTE: Describe Storage files not
//       the Workbook database record

// More strict (no hidding) variation of univer IColumnData

// More strict (no auto/hidding) variation of univer IRowData

// Source: https://github.com/dream-num/univer/blob/9edf924dfb33cc21d8dd43285927deee58e693d0/packages/engine-formula/src/basics/error-type.ts
// Sync with spreadsheetErrors array
var SpreadsheetErrorCodes = /*#__PURE__*/function (SpreadsheetErrorCodes) {
  SpreadsheetErrorCodes["DIV_BY_ZERO"] = "#DIV/0!";
  SpreadsheetErrorCodes["NAME"] = "#NAME?";
  SpreadsheetErrorCodes["VALUE"] = "#VALUE!";
  SpreadsheetErrorCodes["NUM"] = "#NUM!";
  SpreadsheetErrorCodes["NA"] = "#N/A";
  SpreadsheetErrorCodes["CYCLE"] = "#CYCLE!";
  SpreadsheetErrorCodes["REF"] = "#REF!";
  SpreadsheetErrorCodes["SPILL"] = "#SPILL!";
  SpreadsheetErrorCodes["CALC"] = "#CALC!";
  SpreadsheetErrorCodes["ERROR"] = "#ERROR!";
  SpreadsheetErrorCodes["CONNECT"] = "#GETTING_DATA";
  SpreadsheetErrorCodes["NULL"] = "#NULL!";
  SpreadsheetErrorCodes["LIC"] = "#LIC!";
  return SpreadsheetErrorCodes;
}({});

// List of all spreadsheet errors,
// sync with SpreadsheetErrorCodes enums
var spreadsheetErrorCodes = ['#DIV/0!', '#NAME?', '#VALUE!', '#NUM!', '#N/A', '#CYCLE!', '#REF!', '#SPILL!', '#CALC!', '#ERROR!', '#GETTING_DATA', '#NULL!', '#LIC!'];
var SelectionsDimensionsDescription = /*#__PURE__*/function (SelectionsDimensionsDescription) {
  SelectionsDimensionsDescription["Wide"] = "wide";
  SelectionsDimensionsDescription["Tall"] = "tall";
  SelectionsDimensionsDescription["Narrow"] = "narrow";
  SelectionsDimensionsDescription["Flat"] = "flat";
  return SelectionsDimensionsDescription;
}({});

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e  ) {
      t && (r = t);
      var n = 0,
        F = function () {};
      return {
        s: F,
        n: function () {
          return n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[n++]
          };
        },
        e: function (r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function () {
      t = t.call(r);
    },
    n: function () {
      var r = t.next();
      return a = r.done, r;
    },
    e: function (r) {
      u = !0, o = r;
    },
    f: function () {
      try {
        a || null == t.return || t.return();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _defineProperty$1(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty$1(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

// Source: https://github.com/exceljs/exceljs/issues/1687#issuecomment-839663369
var indexedColors = ['000000', 'FFFFFF', 'FF0000', '00FF00', '0000FF', 'FFFF00', 'FF00FF', '00FFFF', '000000', 'FFFFFF', 'FF0000', '00FF00', '0000FF', 'FFFF00', 'FF00FF', '00FFFF', '800000', '008000', '000080', '808000', '800080', '008080', 'C0C0C0', '808080', '9999FF', '993366', 'FFFFCC', 'CCFFFF', '660066', 'FF8080', '0066CC', 'CCCCFF', '000080', 'FF00FF', 'FFFF00', '00FFFF', '800080', '800000', '008080', '0000FF', '00CCFF', 'CCFFFF', 'CCFFCC', 'FFFF99', '99CCFF', 'FF99CC', 'CC99FF', 'FFCC99', '3366FF', '33CCCC', '99CC00', 'FFCC00', 'FF9900', 'FF6600', '666699', '969696', '003366', '339966', '003300', '333300', '993300', '993366', '333399', '333333'];

// Supported formats are mapped to
// Sheetjs support: https://docs.sheetjs.com/docs/miscellany/formats/
var supportedFileTypes = ['csv', 'xlsx', 'numbers', 'ods', 'fods', 'dif', 'xls', 'xlsm', 'xlsb', 'xml', 'xlw', 'xlr', 'sylk/slk', 'prn', 'dbf', 'qpw', 'wps', 'wks', 'rtf', 'eth', 'txt'];

// NOTE: sync with /src/interfaces/reporting/spreadsheets
var errorCodesMessages = {
  DIV_BY_ZERO: 'Occurs when a formula attempts to divide by zero.',
  NA: 'Indicates that the value you are looking for is not available for the formula.',
  NAME: "Indicates the name of a formula or its' values were unrecognizable.",
  NUM: 'Occurs when your formula contains an invalid number.',
  REF: 'Occurs when a formula contains an invalid cell reference.',
  VALUE: 'Occurs when a formula tries to use incorrect types of data.',
  CYCLE: 'Occurs when a formula refers to its own cell, either directly or indirectly.',
  ERROR: 'Indicates that there is an unidentifiable error in a formula.',
  SPILL: 'Occurs when a formula returns multiple results.',
  LIC: 'Occurs when the license key is invalid.'
};

var spreadsheets = /*#__PURE__*/Object.freeze({
  __proto__: null,
  errorCodesMessages: errorCodesMessages,
  indexedColors: indexedColors,
  supportedFileTypes: supportedFileTypes
});

var DEFAULT_COL_WIDTH = 88;
var DEFAULT_ROW_HEIGHT = 24;

// Mappings of Exceljs border styles into Univerjs
// https://univer.ai/api/core/enums/BorderStyleTypes.html
// https://github.com/exceljs/exceljs/blob/5bed18b45e824f409b08456b59b87430ded023ab/index.d.ts#L232
var BORDER_STYLES_KEY = {
  thin: 1,
  hair: 2,
  dotted: 3,
  dashed: 4,
  dashDot: 5,
  dashDotDot: 6,
  double: 7,
  medium: 8,
  mediumDashed: 9,
  mediumDashDot: 10,
  mediumDashDotDot: 11,
  slantDashDot: 12,
  thick: 13
};

// Mappings of Exceljs horizontal aligns into Univerjs
// https://univer.ai/api/core/enums/HorizontalAlign.html
var H_ALIGN_KEYS = {
  left: 1,
  center: 2,
  right: 3,
  justify: 4,
  // Unsupported, using unspecified `0`
  fill: 0,
  centerContinuous: 0,
  distributed: 0
};

// Mappings of Exceljs vertical aligns into Univerjs
// https://univer.ai/api/core/enums/VerticalAlign.html
var V_ALIGN_KEYS = {
  top: 1,
  middle: 2,
  bottom: 3,
  // Unsupported, using unspecified `0`
  distributed: 0,
  justify: 0
};

// Mappings of Exceljs underline styles into Univerjs
// https://github.com/exceljs/exceljs/blob/5bed18b45e824f409b08456b59b87430ded023ab/index.d.ts#L226C44-L226C50
// https://univer.ai/api/core/enums/TextDecoration.html
var UNDERLINE_KEYS = {
  none: 11,
  single: 12,
  double: 10,
  // Unsuported by Univer
  singleAccounting: -1,
  doubleAccounting: -1,
  // Unsuported by ExcelJs
  dash: 0,
  dash_heavy: 3,
  dash_dot_dot_heavy: 1,
  dash_dot_heavy: 2,
  dash_long: 4,
  dash_long_heavy: 5,
  dotted: 8,
  dotted_heavy: 9,
  dot_dash: 6,
  dot_dot_dash: 7,
  thick: 13,
  wave: 14,
  wavy_double: 15,
  wavy_heavy: 16,
  words: 17
};

// Convert Exceljs worksheet row/column
// dimensions to relatively sized worksheet grids
function worksheetToGrid(ws) {
  var colWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_COL_WIDTH;
  var rowHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_ROW_HEIGHT;
  var _ws$properties = ws.properties,
    defaultRowHeight = _ws$properties.defaultRowHeight,
    defaultColWidth = _ws$properties.defaultColWidth;
  if (defaultRowHeight === undefined || defaultColWidth === undefined) {
    return {
      rowData: {},
      columnData: {}
    };
  }

  // @ts-ignore
  var rowData = ws._rows.reduce(function (acc, row, index) {
    if (row.height && row.height !== defaultRowHeight) {
      var relHeight = row.height / defaultRowHeight;
      acc[index] = {
        h: Math.round(relHeight * rowHeight)
      };
    }
    return acc;
  }, {});
  var columnData = ws.columns.reduce(function (acc, col, index) {
    if (col.width && col.width !== defaultColWidth) {
      var relWidth = col.width / defaultColWidth;
      acc[index] = {
        w: Math.round(relWidth * colWidth)
      };
    }
    return acc;
  }, {});
  return {
    rowData: rowData,
    columnData: columnData
  };
}

// Convert each worksheet into a cell data object
// containing only styles recoverable from each cell
function worksheetToCellData(ws, themeColors) {
  var cellData = {};
  ws.eachRow(function (row, rowIndex) {
    row.eachCell(function (cell, colIndex) {
      var styleData = cellStyleToLocalCellStyle(cell, themeColors);
      if (styleData) {
        cellData["".concat(rowIndex - 1)] = cellData["".concat(rowIndex - 1)] || {};
        cellData["".concat(rowIndex - 1)]["".concat(colIndex - 1)] = {
          s: styleData
        };
      }
    });
  });
  return cellData;
}
// Convert an Exceljs cell into a workbook style
function cellStyleToLocalCellStyle(cell, themeColors) {
  var result = {};

  // Map alignment styles to result
  if (cell.alignment) {
    var hAlign = H_ALIGN_KEYS[cell.alignment.horizontal || ''];
    var vAlign = V_ALIGN_KEYS[cell.alignment.vertical || ''];
    var textRotation = cell.alignment.textRotation || 0; // default: no rotation
    var rotation = textRotation === 'vertical' ? {
      v: 1,
      a: 0
    } : {
      a: textRotation
    };
    if (cell.alignment.wrapText === true) result.tb = 3;
    if (cell.alignment.readingOrder === 'rtl') result.td = 2;
    if (cell.alignment.readingOrder === 'ltr') result.td = 1;
    if (hAlign) result.ht = hAlign; // ignore unspecified
    if (vAlign) result.vt = vAlign; // ignore unspecified
    if (rotation.v || rotation.a) result.tr = rotation; // Ignore 0 (unrotated)
  }

  // Map border data to result
  if (cell.border) {
    result.bd = {};
    if (cell.border.top) {
      result.bd.t = cellBorderToLocalCellBorder(cell.border.top, themeColors);
    }
    if (cell.border.right) {
      result.bd.r = cellBorderToLocalCellBorder(cell.border.right, themeColors);
    }
    if (cell.border.bottom) {
      result.bd.b = cellBorderToLocalCellBorder(cell.border.bottom, themeColors);
    }
    if (cell.border.left) {
      result.bd.l = cellBorderToLocalCellBorder(cell.border.left, themeColors);
    }
    if (!Object.keys(result.bd).length) delete result.bd;
  }

  // Apply background styles from fill
  if (cell.fill) {
    result.bg = cellFillToCellBackground(cell.fill, themeColors);
  }

  // Apply font styles
  if (cell.font) {
    if (cell.font.name) result.ff = cell.font.name;
    if (cell.font.size) result.fs = cell.font.size;
    if (cell.font.bold === true) result.bl = 1; // ignore false
    if (cell.font.italic === true) result.it = 1; // ignore false
    if (cell.font.strike === true) {
      result.st = {
        s: 1
      }; // TODO check this works
    }

    // Add font vertical alignments
    if (cell.font.vertAlign === 'subscript') result.va = 2;
    if (cell.font.vertAlign === 'superscript') result.va = 3;
    if (cell.font.underline) {
      var ul = underlineToTextDecortation(cell.font.underline);
      if (ul) result.ul = ul;
    }
    if (cell.font.color) {
      result.cl = colorToLocalColorStyle(cell.font.color, themeColors);
    }
  }

  // TODO remove null attrs from result
  return Object.keys(result).length ? result : null;
}

// Convert a ExcelJs border to a Cell Border
function cellBorderToLocalCellBorder(border, themeColors) {
  var style = border.style,
    color = border.color;
  var result = {
    s: 0,
    cl: {}
  };
  var borderStyle = BORDER_STYLES_KEY[style || ''] || 0; // default: unspecified

  if (borderStyle) result.s = borderStyle; // ignore unspecified
  if (color) result.cl = colorToLocalColorStyle(color, themeColors);
  return result;
}

// Convert background patterns and gradients
// to local single color background fills
function cellFillToCellBackground(fill, themeColors) {
  var color = null;
  if (fill.type === 'pattern') {
    color = fill.fgColor || fill.bgColor || null;
  } else if (fill.type === 'gradient') {
    var _fill$stops = _slicedToArray(fill.stops, 1),
      stop = _fill$stops[0]; // Get 1st color in gradient
    color = stop && stop.color || null;
  }
  return color ? colorToLocalColorStyle(color, themeColors) : null;
}

// Convert a ExcelJs underline to a local
// text decoration instance or null
function underlineToTextDecortation(underline) {
  var result = {
    s: 1
  };
  var underlineVal = UNDERLINE_KEYS[typeof underline === 'string' ? underline : ''];
  if (underline === true) {
    result.t = UNDERLINE_KEYS.single;
  }
  if (underlineVal !== undefined && underlineVal > -1) {
    result.t = underlineVal;
  }
  return result.t ? result : null;
}

// Convert an ExcelJs color to a local color
function colorToLocalColorStyle(color, themeColors) {
  var result = {};
  // @ts-ignore
  var indexed = color.indexed;
  // @ts-ignore
  var theme = color.theme;
  // Theme numbers require -3, then -1 to zero-index 🤷‍♂️
  // https://github.com/exceljs/exceljs/issues/1690#issuecomment-1334730098
  var themeIndex = typeof theme === 'number' ? theme - 4 : -1;

  // TODO support tinting:
  // `{theme: 4, tint: -0.25}`
  // Solution (pSBC) here: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors#answer-13542669

  if (color.argb) {
    result.rgb = "#".concat(color.argb.slice(-6)); // Ignore alpha prefix data
  } else if (themeIndex > -1 && themeColors[themeIndex]) {
    result.rgb = themeColors[themeIndex];
  }
  if (!result.rgb && typeof indexed === 'number' && indexedColors[indexed]) {
    result.rgb = "#".concat(indexedColors[indexed]); // convert to HEX
  }
  return result;
}

var exceljs = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cellBorderToLocalCellBorder: cellBorderToLocalCellBorder,
  cellFillToCellBackground: cellFillToCellBackground,
  cellStyleToLocalCellStyle: cellStyleToLocalCellStyle,
  colorToLocalColorStyle: colorToLocalColorStyle,
  underlineToTextDecortation: underlineToTextDecortation,
  worksheetToCellData: worksheetToCellData,
  worksheetToGrid: worksheetToGrid
});

var ordinals = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelfth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth', 'twentieth', 'twenty-first', 'twenty-second', 'twenty-third', 'twenty-fourth', 'twenty-fifth', 'twenty-sixth', 'twenty-seventh', 'twenty-eighth', 'twenty-ninth', 'thirtieth'];

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ordinals: ordinals,
  spreadsheets: spreadsheets
});

// Wrap an error for logging but ensure that call stack is entact
var createWrappedError = function createWrappedError(msg, err) {
  var wrappedErr = Error("".concat(msg, "?").concat(err ? ': ' : '').concat(err ? err : ''));
  wrappedErr.stack = err.stack;
  return wrappedErr;
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq_1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  return index < 0 ? undefined : data[index][1];
}
var _listCacheGet = listCacheGet;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return _assocIndexOf(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
    index = _assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = _listCacheClear;
ListCache.prototype['delete'] = _listCacheDelete;
ListCache.prototype.get = _listCacheGet;
ListCache.prototype.has = _listCacheHas;
ListCache.prototype.set = _listCacheSet;
var _ListCache = ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new _ListCache();
  this.size = 0;
}
var _stackClear = stackClear;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
    result = data['delete'](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */
var freeGlobal = _typeof(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

/** Built-in value references. */
var _Symbol2 = _root.Symbol;
var _Symbol = _Symbol2;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$c.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$9.call(value, symToStringTag$1),
    tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$b.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? _getRawTag(value) : _objectToString(value);
}
var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = _typeof(value);
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
  funcTag$2 = '[object Function]',
  genTag$1 = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = _baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction;

/** Used to detect overreaching core-js shims. */
var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked;

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
  objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}
var _baseIsNative = baseIsNative;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}
var _getNative = getNative;

/* Built-in method references that are verified to be native. */
var Map = _getNative(_root, 'Map');
var _Map = Map;

/* Built-in method references that are verified to be native. */
var nativeCreate = _getNative(Object, 'create');
var _nativeCreate = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
  this.size = 0;
}
var _hashClear = hashClear;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (_nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}
var _hashGet = hashGet;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$6.call(data, key);
}
var _hashHas = hashHas;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}
var _hashSet = hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = _hashClear;
Hash.prototype['delete'] = _hashDelete;
Hash.prototype.get = _hashGet;
Hash.prototype.has = _hashHas;
Hash.prototype.set = _hashSet;
var _Hash = Hash;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new _Hash(),
    'map': new (_Map || _ListCache)(),
    'string': new _Hash()
  };
}
var _mapCacheClear = mapCacheClear;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = _typeof(value);
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var _isKeyable = isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var _getMapData = getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = _getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return _getMapData(this, key).get(key);
}
var _mapCacheGet = mapCacheGet;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return _getMapData(this, key).has(key);
}
var _mapCacheHas = mapCacheHas;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = _getMapData(this, key),
    size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
    length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = _mapCacheClear;
MapCache.prototype['delete'] = _mapCacheDelete;
MapCache.prototype.get = _mapCacheGet;
MapCache.prototype.has = _mapCacheHas;
MapCache.prototype.set = _mapCacheSet;
var _MapCache = MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof _ListCache) {
    var pairs = data.__data__;
    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new _MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new _ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = _stackClear;
Stack.prototype['delete'] = _stackDelete;
Stack.prototype.get = _stackGet;
Stack.prototype.has = _stackHas;
Stack.prototype.set = _stackSet;
var _Stack = Stack;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
    length = array == null ? 0 : array.length;
  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}
var _arrayEach = arrayEach;

var defineProperty = function () {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();
var _defineProperty = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && _defineProperty) {
    _defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
    _baseAssignValue(object, key, value);
  }
}
var _assignValue = assignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index = -1,
    length = props.length;
  while (++index < length) {
    var key = props[index];
    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      _baseAssignValue(object, key, newValue);
    } else {
      _assignValue(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
    result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && _typeof(value) == 'object';
}
var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$4.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
};
var isArguments_1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;
var isArray_1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? _root.Buffer : undefined;

  /* Built-in method references for those with the same name as other `lodash` methods. */
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

  /**
   * Checks if `value` is a buffer.
   *
   * @static
   * @memberOf _
   * @since 4.3.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
   * @example
   *
   * _.isBuffer(new Buffer(2));
   * // => true
   *
   * _.isBuffer(new Uint8Array(2));
   * // => false
   */
  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = _typeof(value);
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var _isIndex = isIndex;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
  arrayTag$1 = '[object Array]',
  boolTag$2 = '[object Boolean]',
  dateTag$2 = '[object Date]',
  errorTag$1 = '[object Error]',
  funcTag$1 = '[object Function]',
  mapTag$4 = '[object Map]',
  numberTag$2 = '[object Number]',
  objectTag$2 = '[object Object]',
  regexpTag$2 = '[object RegExp]',
  setTag$4 = '[object Set]',
  stringTag$2 = '[object String]',
  weakMapTag$2 = '[object WeakMap]';
var arrayBufferTag$2 = '[object ArrayBuffer]',
  dataViewTag$3 = '[object DataView]',
  float32Tag$2 = '[object Float32Array]',
  float64Tag$2 = '[object Float64Array]',
  int8Tag$2 = '[object Int8Array]',
  int16Tag$2 = '[object Int16Array]',
  int32Tag$2 = '[object Int32Array]',
  uint8Tag$2 = '[object Uint8Array]',
  uint8ClampedTag$2 = '[object Uint8ClampedArray]',
  uint16Tag$2 = '[object Uint16Array]',
  uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] = typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] = typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] = typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] = typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] = typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] = typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] = typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
}
var _baseIsTypedArray = baseIsTypedArray;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}
var _baseUnary = baseUnary;

var _nodeUtil = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && _freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  module.exports = nodeUtil;
});

/* Node.js helper references. */
var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
var isTypedArray_1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray_1(value),
    isArg = !isArr && isArguments_1(value),
    isBuff = !isArr && !isArg && isBuffer_1(value),
    isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
    skipIndexes = isArr || isArg || isBuff || isType,
    result = skipIndexes ? _baseTimes(value.length, String) : [],
    length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    _isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
    proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$4;
  return value === proto;
}
var _isPrototype = isPrototype;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = _overArg(Object.keys, Object);
var _nativeKeys = nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!_isPrototype(object)) {
    return _nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength_1(value.length) && !isFunction_1(value);
}
var isArrayLike_1 = isArrayLike;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
}
var keys_1 = keys;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && _copyObject(source, keys_1(source), object);
}
var _baseAssign = baseAssign;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject_1(object)) {
    return _nativeKeysIn(object);
  }
  var isProto = _isPrototype(object),
    result = [];
  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
}
var keysIn_1 = keysIn;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && _copyObject(source, keysIn_1(source), object);
}
var _baseAssignIn = baseAssignIn;

var _cloneBuffer = createCommonjsModule(function (module, exports) {
  /** Detect free variable `exports`. */
  var freeExports = exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Built-in value references. */
  var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

  /**
   * Creates a clone of  `buffer`.
   *
   * @private
   * @param {Buffer} buffer The buffer to clone.
   * @param {boolean} [isDeep] Specify a deep clone.
   * @returns {Buffer} Returns the cloned buffer.
   */
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module.exports = cloneBuffer;
});

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
    length = source.length;
  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}
var _copyArray = copyArray;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
    length = array == null ? 0 : array.length,
    resIndex = 0,
    result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}
var stubArray_1 = stubArray;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return _arrayFilter(nativeGetSymbols$1(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return _copyObject(source, _getSymbols(source), object);
}
var _copySymbols = copySymbols;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
    length = values.length,
    offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush;

/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray_1 : function (object) {
  var result = [];
  while (object) {
    _arrayPush(result, _getSymbols(object));
    object = _getPrototype(object);
  }
  return result;
};
var _getSymbolsIn = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return _copyObject(source, _getSymbolsIn(source), object);
}
var _copySymbolsIn = copySymbolsIn;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return _baseGetAllKeys(object, keys_1, _getSymbols);
}
var _getAllKeys = getAllKeys;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
}
var _getAllKeysIn = getAllKeysIn;

/* Built-in method references that are verified to be native. */
var DataView = _getNative(_root, 'DataView');
var _DataView = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = _getNative(_root, 'Promise');
var _Promise = Promise$1;

/* Built-in method references that are verified to be native. */
var Set = _getNative(_root, 'Set');
var _Set = Set;

/* Built-in method references that are verified to be native. */
var WeakMap = _getNative(_root, 'WeakMap');
var _WeakMap = WeakMap;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
  objectTag$1 = '[object Object]',
  promiseTag = '[object Promise]',
  setTag$3 = '[object Set]',
  weakMapTag$1 = '[object WeakMap]';
var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = _toSource(_DataView),
  mapCtorString = _toSource(_Map),
  promiseCtorString = _toSource(_Promise),
  setCtorString = _toSource(_Set),
  weakMapCtorString = _toSource(_WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = _baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2 || _Map && getTag(new _Map()) != mapTag$3 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$3 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
  getTag = function getTag(value) {
    var result = _baseGetTag(value),
      Ctor = result == objectTag$1 ? value.constructor : undefined,
      ctorString = Ctor ? _toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag$2;
        case mapCtorString:
          return mapTag$3;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag$3;
        case weakMapCtorString:
          return weakMapTag$1;
      }
    }
    return result;
  };
}
var _getTag = getTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
    result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}
var _initCloneArray = initCloneArray;

/** Built-in value references. */
var Uint8Array = _root.Uint8Array;
var _Uint8Array = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new _Uint8Array(result).set(new _Uint8Array(arrayBuffer));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var _cloneDataView = cloneDataView;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}
var _cloneRegExp = cloneRegExp;

/** Used to convert symbols to primitives and strings. */
var symbolProto = _Symbol ? _Symbol.prototype : undefined,
  symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
var _cloneSymbol = cloneSymbol;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? _cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
  dateTag$1 = '[object Date]',
  mapTag$2 = '[object Map]',
  numberTag$1 = '[object Number]',
  regexpTag$1 = '[object RegExp]',
  setTag$2 = '[object Set]',
  stringTag$1 = '[object String]',
  symbolTag$1 = '[object Symbol]';
var arrayBufferTag$1 = '[object ArrayBuffer]',
  dataViewTag$1 = '[object DataView]',
  float32Tag$1 = '[object Float32Array]',
  float64Tag$1 = '[object Float64Array]',
  int8Tag$1 = '[object Int8Array]',
  int16Tag$1 = '[object Int16Array]',
  int32Tag$1 = '[object Int32Array]',
  uint8Tag$1 = '[object Uint8Array]',
  uint8ClampedTag$1 = '[object Uint8ClampedArray]',
  uint16Tag$1 = '[object Uint16Array]',
  uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return _cloneArrayBuffer(object);
    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);
    case dataViewTag$1:
      return _cloneDataView(object, isDeep);
    case float32Tag$1:
    case float64Tag$1:
    case int8Tag$1:
    case int16Tag$1:
    case int32Tag$1:
    case uint8Tag$1:
    case uint8ClampedTag$1:
    case uint16Tag$1:
    case uint32Tag$1:
      return _cloneTypedArray(object, isDeep);
    case mapTag$2:
      return new Ctor();
    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);
    case regexpTag$1:
      return _cloneRegExp(object);
    case setTag$2:
      return new Ctor();
    case symbolTag$1:
      return _cloneSymbol(object);
  }
}
var _initCloneByTag = initCloneByTag;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = function () {
  function object() {}
  return function (proto) {
    if (!isObject_1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = undefined;
    return result;
  };
}();
var _baseCreate = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return typeof object.constructor == 'function' && !_isPrototype(object) ? _baseCreate(_getPrototype(object)) : {};
}
var _initCloneObject = initCloneObject;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike_1(value) && _getTag(value) == mapTag$1;
}
var _baseIsMap = baseIsMap;

/* Node.js helper references. */
var nodeIsMap = _nodeUtil && _nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? _baseUnary(nodeIsMap) : _baseIsMap;
var isMap_1 = isMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike_1(value) && _getTag(value) == setTag$1;
}
var _baseIsSet = baseIsSet;

/* Node.js helper references. */
var nodeIsSet = _nodeUtil && _nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? _baseUnary(nodeIsSet) : _baseIsSet;
var isSet_1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
  CLONE_FLAT_FLAG = 2,
  CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
  arrayTag = '[object Array]',
  boolTag = '[object Boolean]',
  dateTag = '[object Date]',
  errorTag = '[object Error]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  mapTag = '[object Map]',
  numberTag = '[object Number]',
  objectTag = '[object Object]',
  regexpTag = '[object RegExp]',
  setTag = '[object Set]',
  stringTag = '[object String]',
  symbolTag = '[object Symbol]',
  weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]',
  dataViewTag = '[object DataView]',
  float32Tag = '[object Float32Array]',
  float64Tag = '[object Float64Array]',
  int8Tag = '[object Int8Array]',
  int16Tag = '[object Int16Array]',
  int32Tag = '[object Int32Array]',
  uint8Tag = '[object Uint8Array]',
  uint8ClampedTag = '[object Uint8ClampedArray]',
  uint16Tag = '[object Uint16Array]',
  uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
    isDeep = bitmask & CLONE_DEEP_FLAG$1,
    isFlat = bitmask & CLONE_FLAT_FLAG,
    isFull = bitmask & CLONE_SYMBOLS_FLAG$1;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject_1(value)) {
    return value;
  }
  var isArr = isArray_1(value);
  if (isArr) {
    result = _initCloneArray(value);
    if (!isDeep) {
      return _copyArray(value, result);
    }
  } else {
    var tag = _getTag(value),
      isFunc = tag == funcTag || tag == genTag;
    if (isBuffer_1(value)) {
      return _cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || isFunc && !object) {
      result = isFlat || isFunc ? {} : _initCloneObject(value);
      if (!isDeep) {
        return isFlat ? _copySymbolsIn(value, _baseAssignIn(result, value)) : _copySymbols(value, _baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = _initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new _Stack());
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);
  if (isSet_1(value)) {
    value.forEach(function (subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap_1(value)) {
    value.forEach(function (subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }
  var keysFunc = isFull ? isFlat ? _getAllKeysIn : _getAllKeys : isFlat ? keysIn_1 : keys_1;
  var props = isArr ? undefined : keysFunc(value);
  _arrayEach(props || value, function (subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    _assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}
var _baseClone = baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
  CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return _baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
var cloneDeep_1 = cloneDeep;

var CURRENCY_SYMBOLS = /[$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20BD\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6]/g;

// Parse a monetary string
// into a floating point number
function toFloatingPoint(value) {
  return parseFloat((parseFloat(stripCurrencySymbol("".concat(value)).replace(/,/g, '') || '0') || 0).toFixed(2));
}

// Remove all currency symbols from string
function stripCurrencySymbol(value) {
  return "".concat(value).replace(CURRENCY_SYMBOLS, '');
}

// Convert an ordinal string to it's
// equivalent zero indexed number
function deordinalize(ordinal) {
  return ordinals.indexOf(ordinal);
}

// Is value acceptable as a numeric
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isValidNumber(srcValue) {
  var acceptMoney = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var value = acceptMoney ? toNumericString(srcValue) : srcValue;
  return !isNaN(Number(value)) && "".concat(srcValue).split('.').length < 3;
}

// Convert to a numeric string
// removing all currency and commas
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function toNumericString(str) {
  return stripCurrencySymbol("".concat(str)).replace(/,/g, '');
}

// Coerce any value into a number
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forceToNumber(val) {
  if (typeof val === 'number') return isNaN(val) ? 0 : val;
  if (typeof val === 'boolean') return val === true ? 1 : 0;
  if (_typeof(val) === 'object') return val ? 1 : 0; // Convert objects to binary

  // Sum value of a strings characters
  // into a single value
  return "".concat(val || '').split('').map(function (char) {
    return parseInt(char, 36) || 0;
  }).reduce(function (acc, num) {
    acc += num;
    return acc;
  }, 0);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// Map over every cell in a matrix with a
// callback from top left to bottom right
function mapMatrix(matrix, callback) {
  var _getMatrixDimensions = getMatrixDimensions(matrix),
    width = _getMatrixDimensions.width,
    height = _getMatrixDimensions.height;
  for (var rowIdx = 0; rowIdx < height; rowIdx++) {
    for (var colIdx = 0; colIdx < width; colIdx++) {
      callback(rowIdx, colIdx);
    }
  }
}

// Count number of cells within any grid/matrix
// ignores undefined cells that should exist to
// form an expected rectangular grid
function countMatrixCells(matrix) {
  var count = 0;
  mapMatrix(matrix, function () {
    return count++;
  });
  return count;
}

// Get the dimensions of a matrix
// based on the widest row and
// the tallest column
function getMatrixDimensions(matrix) {
  var maxWidth = matrix.reduce(function (w, row) {
    return Math.max(w, row.length);
  }, 0);
  return {
    width: maxWidth,
    height: matrix.length
  };
}

// Greedily convert all cells that contain
// numeric compatible values to numbers
function createNumerifiedMatrix(matrix) {
  var result = cloneDeep_1(matrix);
  mapMatrix(result, function (rowIdx, colIdx) {
    var value = result[rowIdx][colIdx];
    if (typeof value === 'string' && isValidNumber(value, false)) {
      var update = parseFloat("".concat(value).trim());
      if (!isNaN(update) && update < Infinity && update > Number.NEGATIVE_INFINITY) {
        result[rowIdx][colIdx] = update;
      }
    }
  });
  return result;
}

// Get the index of the cell
// if you flattend the matrix
// into an array of single values
function getFlattendMatrixCellIndex(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
matrix, rowIndex, colIndex) {
  var index = -1;
  for (var i = 0; i <= rowIndex; i++) {
    var row = matrix[i];
    if (row === undefined) return -1;
    for (var k = 0; k < row.length; k++) {
      index += 1;
      if (i === rowIndex && k === colIndex) return index;
    }
  }
  return -1;
}

// Get all cells at a specified column, allow an optional column limit
function getColumn(matrix, colIndex, limit) {
  var maxRows = limit || matrix.length;
  return matrix.reduce(function (column, row, rowIndex) {
    if (rowIndex < maxRows && Array.isArray(row)) {
      column.push(row[colIndex]);
    }
    return column;
  }, []);
}

// Trim the right and bottom most
// edges from the provided matrix
function trimEdgesTo(srcData, bottomIdx, rightIdx) {
  var data = cloneDeep_1(srcData);
  var rowIdx = Math.max(1, Math.min(bottomIdx, data.length));
  return data.slice(0, rowIdx).reduce(function (acc, row) {
    acc.push(row.slice(0, Math.max(1, Math.min(rightIdx, row.length))));
    return acc;
  }, []);
}

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  countMatrixCells: countMatrixCells,
  createNumerifiedMatrix: createNumerifiedMatrix,
  createWrappedError: createWrappedError,
  deordinalize: deordinalize,
  forceToNumber: forceToNumber,
  getColumn: getColumn,
  getFlattendMatrixCellIndex: getFlattendMatrixCellIndex,
  getMatrixDimensions: getMatrixDimensions,
  isValidNumber: isValidNumber,
  mapMatrix: mapMatrix,
  stripCurrencySymbol: stripCurrencySymbol,
  toFloatingPoint: toFloatingPoint,
  toNumericString: toNumericString,
  trimEdgesTo: trimEdgesTo
});

var ERROR_CODES = {
  themeParse: "spreadsheetParseErrorsThemeParse",
  noStylesFound: "spreadsheetParseErrorsNoStylesFound"
};

// Create theme parsing error/warning
var createThemeParsingError = function createThemeParsingError(prefix, err) {
  // TODO: create wrapped error
  var parseErr = createWrappedError("".concat(prefix, " failed to parse ExcelJs theme: ").concat(err), err);

  // @ts-ignore
  parseErr.code = ERROR_CODES.themeParse;
  return parseErr;
};

// No styles found for during parsing
var createNoStylesFoundError = function createNoStylesFoundError(prefix) {
  var actionErr = new Error("".concat(prefix, " no styles found"));

  // @ts-ignore
  actionErr.code = ERROR_CODES.noStylesFound;
  return actionErr;
};

/** Built-in value references. */
var spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray_1(value) || isArguments_1(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
    length = array.length;
  predicate || (predicate = _isFlattenable);
  result || (result = []);
  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        _arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? _baseFlatten(array, 1) : [];
}
var flatten_1 = flatten;

// Convert Excel cell references
// into a list of sheet addresses
// Option: limit the row/column selections
// contentful worksheet data dimensions
function cellReferencesToAddress(cellReference) {
  var sheetIndex = getSpreadsheetIndex(cellReference);
  return splitCellRefs(cellReference).map(singleCellReferenceToAddress).map(function (addr) {
    addr.sheet = sheetIndex;
    return addr;
  });
}

// Create a matrix of addresses
// corresponding to a selection
function cellReferencesToAddressMatrix(srcCellReference, workbook) {
  var matrix = [];
  var cellReference = srcCellReference;

  // Convert a single column/row selection into a multi-part
  // selection from the first row/column, to work with our algo
  if (parseColumn(srcCellReference) === srcCellReference) {
    cellReference = "".concat(cellReference, "1:").concat(cellReference);
  } else if (parseRow(srcCellReference) === srcCellReference) {
    cellReference = "A".concat(cellReference, ":").concat(cellReference);
  }
  var _cellReferencesToAddr = cellReferencesToAddress(cellReference).map(function (addr) {
      if (addr.col !== Infinity && addr.row !== Infinity) {
        return addr;
      }

      // Warning for row/column selections without workbook
      if (!workbook) {
        throw Error('Cannot create matrix for row/column selections providing workbook');
      }

      // Only provide relevent parts of
      // worksheet to improve trim accuracy 
      var sheet = workbook[addr.sheet];
      var trimmedSheet = trimEdgesTo(sheet, addr.row + 1, addr.col + 1);
      return trimSheetAddressToWorksheet(addr, trimmedSheet);
    }),
    _cellReferencesToAddr2 = _slicedToArray(_cellReferencesToAddr, 2),
    first = _cellReferencesToAddr2[0],
    last = _cellReferencesToAddr2[1];
  var lastRow = (last ? last.row : first.row) + 1;
  var lastCol = (last ? last.col : first.col) + 1;
  var sheetIndex = first.sheet;

  // Itterate rows
  for (var i = first.row; i < lastRow; i++) {
    var relativeRowIndex = i - first.row;
    if (!matrix[relativeRowIndex]) matrix.push([]); // Add row to matrix

    // Itterate row's columns
    for (var k = first.col; k < lastCol; k++) {
      matrix[relativeRowIndex].push(coordinatesToAddress(i, k, sheetIndex));
    }
  }
  return matrix;
}

// Convert a spreadsheet into
// a matrix of addresses
function spreadsheetDataToAddressMatrix(spreadsheet) {
  var sheetIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var result = cloneDeep_1(spreadsheet);
  mapMatrix(spreadsheet, function (rowIdx, colIdx) {
    result[rowIdx][colIdx] = coordinatesToAddress(rowIdx, colIdx, sheetIndex);
  });
  return result;
}
function describeCellReferenceDimensions(cellReferences) {
  var addressGroups = cellReferences.map(cellReferencesToAddress);
  var lowestColumnIndex = addressGroups.reduce(function (lowestIndex, _ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      firstAddr = _ref2[0];
    return firstAddr.col < lowestIndex ? firstAddr.col : lowestIndex;
  }, Infinity);
  var highestColumnIndex = addressGroups.reduce(function (highestIndex, addrs) {
    var lastAddr = addrs[addrs.length - 1];
    return lastAddr.col > highestIndex ? lastAddr.col : highestIndex;
  }, -1);
  var lowestRowIndex = addressGroups.reduce(function (lowestIndex, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 1),
      firstAddr = _ref4[0];
    return firstAddr.row < lowestIndex ? firstAddr.row : lowestIndex;
  }, Infinity);
  var highestRowIndex = addressGroups.reduce(function (highestIndex, addrs) {
    var lastAddr = addrs[addrs.length - 1];
    return lastAddr.row > highestIndex ? lastAddr.row : highestIndex;
  }, -1);
  var widthDifferential = highestColumnIndex - lowestColumnIndex;
  var heightDifferential = highestRowIndex - lowestRowIndex;
  if (widthDifferential === 0) {
    // Narrow/Single column selection
    return SelectionsDimensionsDescription.Narrow;
  } else if (heightDifferential === 0) {
    return SelectionsDimensionsDescription.Flat;
  } else if (widthDifferential > heightDifferential) {
    // Tall/High spreadsheet selection
    return SelectionsDimensionsDescription.Wide;
  } else {
    // Wide/Long spreadsheet selection
    return SelectionsDimensionsDescription.Tall;
  }
}

// Create a description of a matrix, with special
// rules for numeric selections with labels
// TODO: add test coverage
function describeValueMatrixDimensions(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
valueMatrix) {
  var isLabeled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isNumeric = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var _getMatrixDimensions = getMatrixDimensions(valueMatrix),
    width = _getMatrixDimensions.width,
    height = _getMatrixDimensions.height;
  var lastRow = valueMatrix[valueMatrix.length - 1] || [];
  var leftColumn = valueMatrix.map(function (row) {
    return row[0];
  });
  var isBottomRowNumeric = lastRow.every(function (col) {
    return typeof col === 'number';
  });
  var isLeftColLabeled = leftColumn.every(function (col) {
    return typeof col === 'string';
  });
  if (isNumeric && isLabeled && width === height && (isBottomRowNumeric || isLeftColLabeled)) {
    return SelectionsDimensionsDescription.Wide;
  }
  if (width < 2) {
    // Narrow/Single column selection
    return SelectionsDimensionsDescription.Narrow;
  } else if (height < 2) {
    return SelectionsDimensionsDescription.Flat;
  } else if (width > height) {
    // Tall/High spreadsheet selection
    return SelectionsDimensionsDescription.Wide;
  } else {
    // Wide/Long spreadsheet selection
    return SelectionsDimensionsDescription.Tall;
  }
}

// Convert spreadsheet coordinates to address
function coordinatesToAddress(row, col) {
  var sheetIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return {
    col: col,
    row: row,
    ref: "".concat(indexToLetters(col)).concat(row < Infinity ? row + 1 : ''),
    sheet: sheetIndex
  };
}

// Convert coordinates to a selection
function coordinatesToSelection(row, col) {
  var sheetIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return addressesToSelection({
    first: coordinatesToAddress(row, col, sheetIndex)
  });
}

// Convert a number to it's equivalent
// spreadsheet column name
// SYN with functions/src/utils/spreadsheets.ts
function indexToLetters(srcIndex) {
  if (srcIndex === Number.NEGATIVE_INFINITY || srcIndex === Infinity) {
    return '';
  }
  var index = parseInt("".concat(srcIndex), 10);
  if (isNaN(index) || index < 0) {
    return '';
  }
  var letters = '';
  while (index >= 0) {
    letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[index % 26] + letters;
    index = Math.floor(index / 26) - 1;
  }
  return letters;
}

// Convert a column name to it's
// equivalent column index in a matrix
function lettersToIndex(col) {
  return parseColumn(col).split('').reduce(function (r, a) {
    return r * 26 + parseInt(a, 36) - 9;
  }, 0) - 1;
}

// Parse cell reference for the column index
function cellRefToColumnIndex(srcCellRef) {
  var _splitCellRefs = splitCellRefs(srcCellRef),
    _splitCellRefs2 = _slicedToArray(_splitCellRefs, 1),
    cellRef = _splitCellRefs2[0]; // ensure single cell
  var parsedCellRef = cellRef.replace(/\d/g, '');
  if (!parsedCellRef) return -1; // Row selection
  return lettersToIndex(parsedCellRef);
}

// Parse out 1st column occurrence from cell reference
function parseColumn(srcCellRef) {
  var _splitCellRefs3 = splitCellRefs(srcCellRef),
    _splitCellRefs4 = _slicedToArray(_splitCellRefs3, 1),
    cellRef = _splitCellRefs4[0]; // ensure single cell
  return (cellRef.match(/[A-Z]+/) || [''])[0] || '';
}

// Parse out 1st row occurrence from cell reference
function parseRow(srcCellRef) {
  var _splitCellRefs5 = splitCellRefs(srcCellRef),
    _splitCellRefs6 = _slicedToArray(_splitCellRefs5, 1),
    cellRef = _splitCellRefs6[0]; // ensure single cell
  return cellRef.replace(/[A-Z]/g, '') || '';
}

// Get the index of row from cell reference
function cellRefToRowIndex(srcCellRef) {
  var parsedInt = parseInt(parseRow(srcCellRef) || '0', 10);
  return isNaN(parsedInt) ? -1 : Math.max(parsedInt - 1, -1);
}

// Convert cell reference to sheet address
// NOTE: Infinity denotes a column/row selection,
//       all contentful values should be accepted
function singleCellReferenceToAddress(singleCellReference) {
  var col = lettersToIndex(parseColumn(singleCellReference));
  var row = cellRefToRowIndex(singleCellReference);
  return {
    col: col < 0 && row >= 0 ? Infinity : col,
    // Empty column = row selection (accept all)
    row: row < 0 && col >= 0 ? Infinity : row,
    // Empty row = column selection (accept all)
    ref: singleCellReference,
    sheet: getSpreadsheetIndex(singleCellReference)
  };
}

// Convert a cell reference to a
// representation of it's numeric dimensions
function cellReferencesToDimensions(cellReference, workbook) {
  var matrix = cellReferencesToAddressMatrix(cellReference, workbook);
  var widestRow = matrix.reduce(function (acc, row) {
    if (row.length > acc.length) return row;
    return acc;
  }, []);
  return {
    width: widestRow.length,
    height: matrix.length
  };
}

// Use user configured sheet name or fallback
// to auto-generated sheet name
// TODO: test
function getSheetName(idx) {
  var sheetNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return (sheetNames || [])[idx] || "Sheet".concat(idx + 1);
}

// Covert index into sheet name
// TODO: test
function sheetIndexToSheetName(index, sheetNames) {
  return sheetNames[index] || getSheetName(index || 0);
}

// Alias for cellRefToRowIndex
function findRowIndex(cellRef) {
  return cellRefToRowIndex(cellRef);
}

// Alias for cellRefToColumnIndex
function findColumnIndex(cellRef) {
  return cellRefToColumnIndex(cellRef);
}

// Convert one or two addresses to a
// selection string with an optional
// sheet index prepended
function addressesToSelection(_ref5) {
  var first = _ref5.first,
    last = _ref5.last;
  var selection = '';
  if (!last || first.ref === last.ref) {
    selection = first.ref;
  } else {
    selection = "".concat(first.ref, ":").concat(last.ref);
  }
  return prependSheetIndex(selection, first.sheet);
}

// Get the dimensions of a matrix
// based on the widest contentful row
// and the tallest contentful column
function getContentfulMatrixDimensions(update) {
  var maxWidth = update.reduce(function (w, row) {
    var lastIndex = row.reduce(function (idx, value, i) {
      return Math.max(idx, isContentful(value) ? i + 1 : -1);
    }, 0);
    return Math.max(w, lastIndex);
  }, 0);
  var maxHeight = update.reduce(function (h, row, i) {
    var hasContent = row.some(isContentful);
    return Math.max(h, hasContent ? i + 1 : -1);
  }, 0);
  return {
    width: maxWidth,
    height: maxHeight
  };
}

// Check if a spreadsheet value has content
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isContentful(value) {
  return value !== '' && value !== undefined;
}

// Return the overlapping areas
// of two address matrices
function getAddressMatrixUnion(aAddrs, bAddrs) {
  // Check for infinite dimensions in any address
  var allAddresses = [].concat(_toConsumableArray(flatten_1(aAddrs)), _toConsumableArray(flatten_1(bAddrs)));
  if (allAddresses.some(function (addr) {
    return addr.row === Infinity || addr.col === Infinity;
  })) {
    throw new Error('Union for row/column selections not supported');
  }
  var aCellRefs = flatten_1(aAddrs).map(function (_ref6) {
    var ref = _ref6.ref;
    return ref;
  });
  var bCellRefs = flatten_1(bAddrs).map(function (_ref7) {
    var ref = _ref7.ref;
    return ref;
  });
  var aCellRefsSheet = ((aAddrs[0] || [])[0] || {}).sheet;
  var bCellRefsSheet = ((bAddrs[0] || [])[0] || {}).sheet;

  // Cell references from different
  // sheets cannot overlap
  if (aCellRefsSheet !== bCellRefsSheet) {
    return [];
  }

  // Use largest matrix
  // to itterate over
  var largest = countMatrixCells(aAddrs) > countMatrixCells(bAddrs) ? aAddrs : bAddrs;
  return largest.map(function (rowAddresses) {
    return rowAddresses.filter(function (_ref8) {
      var ref = _ref8.ref;
      return aCellRefs.indexOf(ref) > -1 && bCellRefs.indexOf(ref) > -1;
    }).map(function (addr) {
      return _objectSpread2({}, addr);
    });
  } // clone address
  ).filter(function (row) {
    return row.length;
  });
}

// Maps over contentful cells in a selection
// and call provided callback on each cell
function mapContentfulCells(cellRefs, data, callback) {
  var selectionAddressMatrix = cellReferencesToAddressMatrix(toCellRefs(cellRefs), [data]);
  var dataAddressMatrix = spreadsheetDataToAddressMatrix(data);
  var overlappingData = getAddressMatrixUnion(selectionAddressMatrix, dataAddressMatrix);
  mapMatrix(overlappingData, function (rowIdx, colIdx) {
    var addr = overlappingData[rowIdx][colIdx];
    var value = (data[addr.row] || [])[addr.col];
    if (isContentful(value)) {
      callback(rowIdx, colIdx, addr.ref);
    }
  });
}

// Check if a workbook data contains any truethy content
function hasContent(workbookData) {
  return workbookData.some(function (sheet) {
    return sheet.some(function (row) {
      return row.some(isContentful);
    });
  });
}

// Create a spreadsheet selection
// matching an update, relative to
// an optional target cell reference
function getDimensionCellRefs(dimensions) {
  var startCellRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'A1';
  var sheetIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  // Single cell updates have a single cell ref
  if (dimensions.width < 2 && dimensions.height < 2) {
    return startCellRef;
  }
  var startAddress = singleCellReferenceToAddress(startCellRef);

  // Row/column selections cannot be used as a 
  // starting point for dimensional selections
  if (startAddress.row === Infinity || startAddress.col === Infinity) {
    throw new Error('Row and column selections are not supported');
  }
  var lastRow = Math.max(0, startAddress.row + dimensions.height - 1);
  var lastCol = Math.max(0, startAddress.col + dimensions.width - 1);
  var lastCellRef = coordinatesToAddress(lastRow, lastCol, sheetIndex).ref;
  return prependSheetIndex("".concat(startCellRef, ":").concat(lastCellRef), sheetIndex);
}

// Split cell reference(s) into
// individual cell referneces
function splitCellRefs(cellRef) {
  return (cellRef.replace(/^=/, '').split('.').pop() || '').split(':').slice(0, 2);
}

// Lookup the spreadsheet index
// referenced by a spreadsheet selection
function getSpreadsheetIndex(cellRef) {
  var matches = cellRef.trim().match(/^=?(-?\d+)\./) || [];
  var index = matches[1] || '0';
  var result = parseInt(index, 10);

  // Check for NaN and invalid index
  return result === result && result > -1 ? result : 0;
}

// Strip out sheet index selection
// and return only the cell reference(s)
// portion of the selection
function toCellRefs(selection) {
  return splitCellRefs(selection).join(':') || '';
}

// Prepend a spreadsheet index onto a selection
function prependSheetIndex(selection) {
  var sheetIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var cellRefs = splitCellRefs("".concat(selection)).join(':');
  var omitIndex = isNaN(sheetIndex) || sheetIndex === 0;
  return "".concat(omitIndex ? '' : sheetIndex).concat(omitIndex ? '' : '.').concat(cellRefs);
}

// Get the furtherest coordinate of a
// Sheet Address to provided worksheet
function trimSheetAddressToWorksheet(address, sheet) {
  var dimensions = getMatrixDimensions(sheet);
  return coordinatesToAddress(Math.max(0, Math.min(address.row, dimensions.height - 1)), Math.max(0, Math.min(address.col, dimensions.width - 1)), address.sheet);
}

// Convert a matrix of sheet addresses
// into a matrix of values from a worksheet
function addressMatrixToWorksheet(worksheet, refMatrix) {
  return refMatrix.map(function (row) {
    return row.map(function (address) {
      var value = (worksheet[address.row] || [])[address.col];

      // Convert spreadsheet error object to string
      if (_typeof(value) === 'object' && value.type === 'ERROR') {
        return value.value || value.type;
      }
      return value;
    });
  });
}

// Overlap an update matrix over another
// according to a spreadsheet cell selection
function insert(cellRef, source, srcUpdate) {
  var result = cloneDeep_1(source);
  var update = createNumerifiedMatrix(srcUpdate);

  // Ignore multi-cell references,
  // instead creates a new cell reference based
  // on update dimensions and 1st cell ref
  var focusedCellRef = cellRef.split(':')[0];
  var updateDimensions = getMatrixDimensions(update);
  var updateCellRefs = getDimensionCellRefs(updateDimensions, focusedCellRef);
  var relativeRefs = cellReferencesToAddressMatrix(updateCellRefs);
  for (var i = 0; i < relativeRefs.length; i++) {
    var row = relativeRefs[i];
    addNonExistentRows(result, row[0].row);
    for (var k = 0; k < row.length; k++) {
      var address = row[k];
      var value = (update[i] || [])[k];
      addNonExistentColumns(result, address.row, address.col);
      result[address.row][address.col] = value !== undefined ? value : '';
    }
  }

  // Add missing/empty matrix cells
  // so every row has same length
  addPadding(result);

  // Trim empty cells on
  // right/left edges of matrix
  trimEdges(result);
  return result;
}

// Remove all content from a
// selection within a matrix
function remove(cellRef, source) {
  var result = cloneDeep_1(source);
  var relativeRefs = cellReferencesToAddressMatrix(cellRef);
  for (var i = 0; i < relativeRefs.length; i++) {
    var row = relativeRefs[i];
    addNonExistentRows(result, row[0].row);
    for (var k = 0; k < row.length; k++) {
      var address = row[k];
      addNonExistentColumns(result, address.row, address.col);
      result[address.row][address.col] = ''; // Remove content
    }
  }

  // Add missing/empty matrix cells
  // so every row has same length
  addPadding(result);

  // Trim empty cells on
  // right/left edges of matrix
  trimEdges(result);
  return result;
}

// Add non-existing row up to the
// given index in a matrix current
// NOTE: causes side effects
function addNonExistentRows(data, rowIndex) {
  for (var i = 0; i <= rowIndex; i++) {
    if (!Array.isArray(data[i])) {
      data.splice(i, 0, []);
    }
  }
}

// Add non-existing columns in row
// up to the given index
// NOTE: causes side effects
function addNonExistentColumns(data, rowIndex, colIndex) {
  var dataRow = data[rowIndex];
  for (var i = 0; i <= colIndex; i++) {
    if (data[rowIndex][i] === undefined) {
      dataRow.splice(i, 0, '');
    }
  }
}

// Add empty string to empty columns
// NOTE: causes side effects
function addPadding(data) {
  mapMatrix(data, function (rowIdx, colIdx) {
    if (data[rowIdx][colIdx] === undefined) {
      data[rowIdx][colIdx] = '';
    }
  });
}

// Trim the right most and bottom most
// empty spaces from the result matrix
// NOTE: causes side effects
function trimEdges(data) {
  var _getContentfulMatrixD = getContentfulMatrixDimensions(data),
    width = _getContentfulMatrixD.width,
    height = _getContentfulMatrixD.height;
  var _iterator = _createForOfIteratorHelper(data),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var row = _step.value;
      row.splice(width); // trim row excess
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  data.splice(height); // trim column excess
}

// Trim general formatting, which does nothing
// NOTE: causes side effects
function trimGeneral(formatting) {
  Object.keys(formatting).forEach(function (cellRef) {
    var cellFmt = "".concat(formatting[cellRef] || '');
    if (cellFmt.toLowerCase() === 'general') {
      delete formatting[cellRef];
    }
  });
}

var SHEET_LIMIT = 100;
// Parse a workbook file into
// an array of HyperFormula compatible
// Spreadsheet data JSON
// NOTE: Browser/Node.js agnostic
function parseWorkbook(_ref) {
  var file = _ref.file,
    xlsxRead = _ref.xlsxRead,
    _ref$sheetLimit = _ref.sheetLimit,
    sheetLimit = _ref$sheetLimit === void 0 ? SHEET_LIMIT : _ref$sheetLimit;
  var PREFIX = 'spreadsheet: parse:';
  var workbook;
  try {
    workbook = xlsxRead(file, {
      cellNF: true
    });
  } catch (err) {
    throw createWrappedError("".concat(PREFIX, " xlsx read failed"), err);
  }
  var sheetCount = workbook.SheetNames.length;

  // If workbook contains more than the sheet
  // limit throw an error so user can modify
  // the workbook before uploading
  if (sheetCount > sheetLimit) {
    throw Error("".concat(PREFIX, ": parseWorkbook: workbook exceeded spreadsheet page count limit of ").concat(sheetLimit));
  }

  // Convert worksheets to an array
  var worksheets = workbook.SheetNames.map(function (sheetName) {
    return workbook.Sheets[sheetName];
  });

  // Parse each worksheet into spreadsheet data
  return worksheets.map(parseSpreadsheet).reduce(function (result, _ref2, index) {
    var spreadsheet = _ref2.spreadsheet,
      formatting = _ref2.formatting;
    result.workbook.push(spreadsheet);
    if (Object.keys(formatting).length) {
      result.meta.formats.push(formatting);
    }
    result.meta.sheetNames.push((workbook.SheetNames[index] || "Sheet".concat(index + 1)).trim());

    // Add worksheet style parsing #566
    // Add worksheet column/row data parsing #566
    return result;
  }, {
    workbook: [],
    meta: {
      sheetNames: [],
      formats: []
    }
  });
}

// Parse an individual worksheet into
// JSON compatible with Hyperformula
function parseSpreadsheet(sheet) {
  var spreadsheet = [];
  var formatting = {};
  Object.keys(sheet).filter(function (cellRef) {
    return Boolean(sheet[cellRef]) && _typeof(sheet[cellRef]) === 'object' && cellRef.search(/[A-Z]+[0-9]+/i) > -1;
  }).forEach(function (cellRef) {
    var cell = sheet[cellRef];
    var rowIndex = cellRefToRowIndex(cellRef);
    var colIndex = cellRefToColumnIndex(cellRef);
    addNonExistentRows(spreadsheet, rowIndex);
    addNonExistentColumns(spreadsheet, rowIndex, colIndex);

    // Lookup value/function of cell
    var value = typeof cell.f === 'string' ? "=".concat(cell.f) : cell.v;
    if (typeof value === 'undefined') value = '';
    if (cell.t === 'b') value = Boolean(value).toString();
    if (cell.z) formatting[cellRef] = cell.z;

    // Add cell value to spreadsheet
    spreadsheet[rowIndex].splice(colIndex, 0, value);
  });

  // Add missing/empty matrix cells
  // so every row has same length
  addPadding(spreadsheet);

  // Trim empty cells on
  // right/bottom edges of matrix
  trimEdges(spreadsheet);

  // Remove any general formatting
  // which only takes up space
  trimGeneral(formatting);
  return {
    spreadsheet: spreadsheet,
    formatting: formatting
  };
}

// Load a globally accessable instance of XLSX
// compatible with browsers, which seems to be
// recommended as of 10/10/24, keep in sync with backend functions
// https://docs.sheetjs.com/docs/getting-started/installation/standalone
var loadGlobalXlsx = function loadGlobalXlsx() {
  // @ts-ignore
  if (window.XLSX) {
    // @ts-ignore
    return Promise.resolve({
      read: window.XLSX.read
    });
  }
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://cdn.sheetjs.com/xlsx-0.20.3/package/dist/xlsx.full.min.js';
    // @ts-ignore
    script.onload = function () {
      return resolve({
        read: window.XLSX.read
      });
    };
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

// NOTE: only export browser/node agnotic code

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ERROR_CODES: ERROR_CODES,
  addNonExistentColumns: addNonExistentColumns,
  addNonExistentRows: addNonExistentRows,
  addPadding: addPadding,
  addressMatrixToWorksheet: addressMatrixToWorksheet,
  addressesToSelection: addressesToSelection,
  cellRefToColumnIndex: cellRefToColumnIndex,
  cellRefToRowIndex: cellRefToRowIndex,
  cellReferencesToAddress: cellReferencesToAddress,
  cellReferencesToAddressMatrix: cellReferencesToAddressMatrix,
  cellReferencesToDimensions: cellReferencesToDimensions,
  coordinatesToAddress: coordinatesToAddress,
  coordinatesToSelection: coordinatesToSelection,
  createNoStylesFoundError: createNoStylesFoundError,
  createThemeParsingError: createThemeParsingError,
  describeCellReferenceDimensions: describeCellReferenceDimensions,
  describeValueMatrixDimensions: describeValueMatrixDimensions,
  findColumnIndex: findColumnIndex,
  findRowIndex: findRowIndex,
  getAddressMatrixUnion: getAddressMatrixUnion,
  getContentfulMatrixDimensions: getContentfulMatrixDimensions,
  getDimensionCellRefs: getDimensionCellRefs,
  getSheetName: getSheetName,
  getSpreadsheetIndex: getSpreadsheetIndex,
  hasContent: hasContent,
  indexToLetters: indexToLetters,
  insert: insert,
  isContentful: isContentful,
  lettersToIndex: lettersToIndex,
  loadGlobalXlsx: loadGlobalXlsx,
  mapContentfulCells: mapContentfulCells,
  parseColumn: parseColumn,
  parseRow: parseRow,
  parseSpreadsheet: parseSpreadsheet,
  parseWorkbook: parseWorkbook,
  prependSheetIndex: prependSheetIndex,
  remove: remove,
  sheetIndexToSheetName: sheetIndexToSheetName,
  singleCellReferenceToAddress: singleCellReferenceToAddress,
  splitCellRefs: splitCellRefs,
  toCellRefs: toCellRefs,
  trimEdges: trimEdges,
  trimGeneral: trimGeneral,
  trimSheetAddressToWorksheet: trimSheetAddressToWorksheet
});

export { SelectionsDimensionsDescription, SpreadsheetErrorCodes, index$2 as config, exceljs, index as spreadsheet, spreadsheetErrorCodes, index$1 as utils };
